/**
 * Validator for SpendNatureDecouple action.
 *
 * Rules (§6.3, §11.1, §14):
 *   1. stateVersion matches.
 *   2. Phase is "marketCheck".
 *   3. Active player has ≥ 1 nature token.
 *   4. market.decoupleUnlockedThisTurn === false (can only unlock once per turn).
 *
 * This action unlocks DraftDecoupled for this turn. It does NOT immediately
 * draft — it just consumes 1 nature token and sets the decouple flag.
 */

import type { SpendNatureDecoupleAction } from "../types/actions";
import type { ValidationResult } from "../types/common";
import type { GameState } from "../types/game-state";
import { commonGuards, VALID } from "./common-guards";

export const validateSpendNatureDecouple = (
  state: GameState,
  action: SpendNatureDecoupleAction,
): ValidationResult => {
  const guard = commonGuards(state, action.stateVersion, "marketCheck");
  if (guard !== null) {
    return guard;
  }

  const activePlayer = state.players[state.turn.activeSeat];
  if (activePlayer === undefined || activePlayer.natureTokens < 1) {
    return {
      valid: false,
      error: "ERR_NATURE_INSUFFICIENT",
      details: { have: activePlayer?.natureTokens ?? 0, need: 1 },
    };
  }

  if (state.market.decoupleUnlockedThisTurn) {
    return {
      valid: false,
      error: "ERR_DECOUPLE_ALREADY_UNLOCKED",
      details: {},
    };
  }

  return VALID;
};
